// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"41725cb1","792":"83801230"}[chunkId] + ".chunk.js";
};